'use client';

import { useTranslation } from 'react-i18next';

import type { ClassCancellationPolicy } from '../_lib/class-cancellation-policy';

export function ClassCancellationDisclosure({
  policy,
}: {
  policy: ClassCancellationPolicy | null | undefined;
}) {
  const { t } = useTranslation('bookings');

  return (
    <section className="space-y-1 border-t pt-4" data-test="class-cancellation-policy">
      <h3 className="text-sm font-medium">{t('cancellationPolicyTitle')}</h3>
      <p className="text-muted-foreground text-sm">
        {!policy
          ? t('classPolicyUnavailable')
          : policy.isNonRefundable
            ? t('classPolicyNoRefunds')
            : t(
                policy.cancellationWindowHours === 0
                  ? 'classPolicyCreditAnytime'
                  : 'classPolicyCreditWindow',
                {
                  window: t('policyHours', {
                    count: policy.cancellationWindowHours,
                  }),
                },
              )}
      </p>
    </section>
  );
}
